import { ZodSchema } from "@validation/utils/schemaUtils";
import { z } from "zod";
import { ConnectingVisitStatus, ConnectingVisitInput } from "__generated__/graphql";
import { connectingVesselSelectSchema } from "view/connectingVessels/utils/connectingVessel.schema";
import { locationSelectOptionSchema } from "view/locations/utils/location.schema";

export const connectingVisitSchema = z.object({
	id: z.number().nullable(),
	vessel: connectingVesselSelectSchema.nullable(),
	port: ZodSchema.requiredField(locationSelectOptionSchema),
	callReferenceNumber: z.string().min(1).max(255),
	status: z.enum(ConnectingVisitStatus),
	eta: z.number().nullable(),
	ata: z.number().nullable(),
	etd: z.number().nullable(),
	atd: z.number().nullable(),
	cargoOpening: z.number().nullable(),
	cargoClosing: z.number().nullable(),
	cargoAvailableStart: z.number().nullable(),
	cargoAvailableEnd: z.number().nullable(),
}).transform((data): ConnectingVisitInput => {
	return {
		...data,
		vessel: data.vessel?.id,
		port: data.port?.id,
	};
});

export type ConnectingVisitSchemaInput = z.input<typeof connectingVisitSchema>;
export type ConnectingVisitSchemaOutput = z.output<typeof connectingVisitSchema>;

export const updateVisitWindowSchema = z.object({
	from: z.number().nullable(),
	to: z.number().nullable(),
});

export type UpdateVisitWindowSchemaInput = z.input<typeof updateVisitWindowSchema>;
export type UpdateVisitWindowSchemaOutput = z.output<typeof updateVisitWindowSchema>;

export const updateBerthingLocationSchema = z.object({
	location: ZodSchema.requiredField(locationSelectOptionSchema),
});

export type UpdateBerthingLocationSchemaInput = z.input<typeof updateBerthingLocationSchema>;
export type UpdateBerthingLocationSchemaOutput = z.output<typeof updateBerthingLocationSchema>;

export const updateBerthingWindowSchema = z.object({
	from: z.number().nullable(),
	to: z.number().nullable(),
});

export type UpdateBerthingWindowSchemaInput = z.input<typeof updateBerthingWindowSchema>;
export type UpdateBerthingWindowSchemaOutput = z.output<typeof updateBerthingWindowSchema>;

export const updateConnectingVisitNotesSchema = z.object({
	notes: z.string(),
	updateLastContactTime: z.boolean(),
});

export type UpdateConnectingVisitNotesSchemaInput = z.input<typeof updateConnectingVisitNotesSchema>;
export type UpdateConnectingVisitNotesSchemaOutput = z.output<typeof updateConnectingVisitNotesSchema>;

export const createConnectingShipBerthingSchema = z.object({
	location: ZodSchema.requiredField(locationSelectOptionSchema),
	from: z.number().nullable(),
	to: z.number().nullable(),
});

export type CreateConnectingShipBerthingSchemaInput = z.input<typeof createConnectingShipBerthingSchema>;
export type CreateConnectingShipBerthingSchemaOutput = z.output<typeof createConnectingShipBerthingSchema>;
